import { render, staticRenderFns } from "./YoutubeLinkEditor.vue?vue&type=template&id=4b06e6db&"
import script from "./YoutubeLinkEditor.vue?vue&type=script&lang=js&"
export * from "./YoutubeLinkEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "YoutubeLinkEditor.vue"
export default component.exports